// extracted by mini-css-extract-plugin
export default {"card":"Gaa-z"};